import { useLang } from "../../../i18n/LangContext";
import { Button } from "../../ui/button";
import { Card, CardContent } from "../../ui/card";
import { Plus } from "lucide-react";
import { Bilingual, emptyL } from "../Bilingual";
import { ContentItemEditor } from "./ContentItemEditor";

const CONTENT_TYPES = ["VIDEO", "TEXT", "IMAGE", "PDF", "CHECKLIST", "QUIZ", "REFLECTION"];
const uid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Math.random()));

export const blankDay = { title: { ...emptyL }, description: { ...emptyL }, status: "DRAFT", content: [] };

export const blankContent = (type) => ({
  content_id: uid(),
  type, order: 0, title: { ...emptyL }, body: { ...emptyL }, url: "",
  items: type === "CHECKLIST" ? [{ ...emptyL }] : [],
  questions: type === "QUIZ" ? [{ question: { ...emptyL }, options: [{ ...emptyL }, { ...emptyL }], correct_index: 0 }] : [],
  pass_score: 70,
});

export function DayForm({ day, onChange, onSave, onCancel }) {
  const { t } = useLang();
  const content = day.content || [];
  const patchContent = (idx, patch) => onChange({ ...day, content: content.map((c, i) => (i === idx ? { ...c, ...patch } : c)) });
  const moveContent = (idx, dir) => {
    const j = idx + dir;
    if (j < 0 || j >= content.length) return;
    const next = [...content];
    [next[idx], next[j]] = [next[j], next[idx]];
    onChange({ ...day, content: next });
  };

  return (
    <Card data-testid="cms-day-form" className="bg-[#10121B] border-[#10B981]/30">
      <CardContent className="p-5 space-y-4">
        <div className="text-xs uppercase tracking-widest text-[#10B981] font-semibold">
          {day.day_id ? `${t("edu.day")} ${day.day_number}` : t("edu.newDay")}
        </div>
        <Bilingual label={t("education.moduleTitle")} testId="cms-day-title" value={day.title} onChange={(v) => onChange({ ...day, title: v })} />
        <Bilingual label={t("common.description")} testId="cms-day-desc" rows={2} value={day.description} onChange={(v) => onChange({ ...day, description: v })} />

        <div className="space-y-3">
          {content.map((c, i) => (
            <ContentItemEditor key={c.content_id || `content-${i}`} item={c} index={i}
              onPatch={(patch) => patchContent(i, patch)}
              onMove={(dir) => moveContent(i, dir)}
              onRemove={() => onChange({ ...day, content: content.filter((_, x) => x !== i) })} />
          ))}
          <div className="flex flex-wrap gap-2">
            {CONTENT_TYPES.map((ct) => (
              <Button key={ct} type="button" variant="outline" data-testid={`cms-add-content-${ct}`}
                onClick={() => onChange({ ...day, content: [...content, blankContent(ct)] })}
                className="h-8 border-white/15 bg-transparent text-slate-200 hover:bg-white/5 hover:text-white text-xs">
                <Plus className="h-3 w-3 mr-1" /> {t(`edu.type_${ct}`)}
              </Button>
            ))}
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onCancel} className="text-slate-300 h-10">{t("common.cancel")}</Button>
          <Button data-testid="cms-day-save-btn" onClick={onSave} className="bg-[#10B981] hover:bg-emerald-500 text-white font-semibold h-10">{t("common.save")}</Button>
        </div>
      </CardContent>
    </Card>
  );
}
